import React, { useState, useCallback, useMemo } from 'react'
import {Collapse, Card} from 'react-bootstrap'
import { Button } from 'rsuite';
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import styles from "./css/CollapsableDiv.module.css";
import logger from '../logger';

type myPropsType = {
    name: string,
    label: string,
    values?: Array<string>,
    open?: boolean,
    notAvailable: boolean,
    onFacetSelected?: (value: string) => void,
    children?: React.ReactNode
}

function CollapsableDiv(props: myPropsType) {
    const [isOpen, setIsOpen] = useState(props.open !== undefined ? props.open : false);

    const toggleOpen = useCallback(() => {
        setIsOpen(prev => !prev);
    }, []);

    const isNotAvailable = props.notAvailable;
    const facetName = props.name;
    const facetLabel = props.label;
    const facetValues = props.values;

    const handleFacetClick = useCallback((aValue: string) => {
        if (props.onFacetSelected !== undefined) {
            props.onFacetSelected(aValue + "@" + facetName);
        }
    }, [props.onFacetSelected, facetName]);

    const compToRenter = useMemo(() => facetValues?.map(aValue => {
        return (
            <div key={aValue}>
                <Button appearance="link"
                    onClick={() => handleFacetClick(aValue)}
                    value={aValue + "@" + facetName}
                    className={isNotAvailable ? styles.glNotAvailable : styles.buttons}>{aValue}</Button>
            </div>
        )
    }), [facetValues, facetName, isNotAvailable, handleFacetClick]);

    return (
        <Card key="facetName">
            <Card.Header>
                <div className={styles.glFlex}>
                    <span className={styles.labelText}>
                        {facetLabel.split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                {index < facetLabel.split('\n').length - 1 && <br />}
                            </React.Fragment>
                        ))}
                    </span>
                    <span className={styles.glCardHeaderRight}>
                        <Button appearance="link"
                            onClick={toggleOpen}
                            className={styles.glSwitchButton}>
                            {isOpen ? <ExpandLess className={styles.glIcon} /> : <ExpandMore className={styles.glIcon} />}
                        </Button>
                    </span>
                </div>
            </Card.Header>

            <Collapse in={isOpen}>
                <div>
                    {compToRenter}
                </div>
            </Collapse>
        </Card>
    );
}

export default React.memo(CollapsableDiv)
